/* eslint-disable max-classes-per-file */
import { Flight } from 'models/flight';
import { FlightFilter } from 'models/flightFilter';
import { LogicalFare } from 'models/logicalFare';
import { Price } from 'models/price';
import { Sector } from 'models/sector';

export class Trip {
  constructor(
    public departurePoint: string,
    public arrivalPoint: string,
    public departureDate: string,
    public cabinCode: string,
    public baggageIncluded: boolean = false,
    public directFlight: boolean = false,
  ) {}
}

export interface ExchangeTrip {
  sectorNumber: number;
  departurePoint: string;
  arrivalPoint: string;
  departureDate: string;
  departureDateWithOutFormat?: string;
  sectorChange: boolean;
  reservationIndex?: number;
}

export type FlightSearchRequest = {
  trips: Trip[];
  currencyCode: string;
  countryId: string;
  sessionToken: string;
  isBusSearch: boolean;
  adults: number;
  children: number;
  infants: number;
  maxResults: number;
};

export interface FlightExchangeRequest {
  trips: ExchangeTrip[];
  currencyCode: string;
  userId: string;
  travelId: string;
  sessionToken: string;
  isBusSearch: boolean;
  adults: number;
  children: number;
  infants: number;
  maxResults: number;
  billingCompanyId?: string;
}

export interface FlightSearchResponse {
  results: FlightGroupedResultResponse[];
  searchId: string;
  resultsAvailableUntil: Date;
  resultsCount: number;
  distanceRestriction: 'Domestic' | 'International';
  lowestLogicalFare?: number;
  lowestLogicalFareList?: LogicalFare[];
  currency?: string;
}

export enum FlightResultRequestOrderCriteriaEnum {
  PRICE = 'PRICE',
  DURATION = 'DURATION',
  RECOMENDATION = 'RECOMENDATION',
  DATE = 'DATE',
}

export interface FlightResultRequest extends FlightFilter {
  userId: string;
  travelArrangerUserId?: string;
  searchId: string;
  resultCountLowerBound: number;
  resultCountUpperBound: number;
  orderCriteria: FlightResultRequestOrderCriteriaEnum;
  distanceRestriction: string;
  lowestLogicalFare?: number;
  sessionToken: string;
  orderDesc: boolean;
}

export interface FlightResultResponse {
  sectors: Sector[];
  price: Price;
  provider: string;
  adultsFareAmount: number;
  childsFareAmount: number;
  infantsFareAmount: number;
  preferenceOrder: number;
  textFare?: string;
  optionId: number;
  isPreApproved: boolean;
  breakRulesMessage?: string[];
  upSellEnabled?: boolean;
  isBus?: boolean;
  lengthOfStay?: number;
  ttl?: string;
}

export interface GroupedSectorOptions {
  flightKeys: string;
  flightKeysAdvanced: string;
  flights: Flight[];
  totalDuration: string;
}

export interface GroupedSector {
  sectorNumber: number;
  options: GroupedSectorOptions[];
}
export interface FlightGroupedResultResponse extends Omit<FlightResultResponse, 'sectors'> {
  sectors: GroupedSector[];
}
